import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20super%20cute%20warm%20yellow%20cartoon%20butter%20bear%20mascot%20sitting%20happily%20in%20a%20cozy%20warm%20toned%20room%20with%20plush%20toys%20and%20soft%20decorations%20around%2C%20warm%20sunlight%20streaming%20through%20sheer%20curtains%2C%20soft%20bokeh%20effect%20in%20background%2C%20cream%20and%20golden%20pastel%20color%20palette%2C%20kawaii%20illustration%20style%20with%20modern%20minimal%20aesthetic%2C%20highly%20detailed%20digital%20art%2C%20editorial%20quality%2C%20healing%20and%20inviting%20atmosphere&width=1600&height=900&seq=hero-butter-bear-2025&orientation=landscape"
          alt="黄油小熊官方落地页 - 可爱治愈系IP周边首选"
          title="黄油小熊 - 可爱治愈系周边首选"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40"></div>
      </div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full text-center px-4">
          <div className="inline-flex items-center gap-2 bg-background-50/20 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-background-50 text-sm font-medium">2025 春季新品温暖上市</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            用温暖治愈每一个日常
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-xl mx-auto mb-8 leading-relaxed">
            黄油小熊 —— 集萌系外观与暖心设计于一体的治愈系IP。精选周边好物，让温暖触手可及。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              探索周边好物
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-50/20"
            >
              了解品牌故事
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}